<template>
  <zg-kh-account-withdraw
    acc-center-router-name="fundAccountHome"
    @resultHandler="resultHandler"
  ></zg-kh-account-withdraw>
</template>

<script>
import { AccountWithdraw } from 'zgkaihu'
export default {
  name: 'FundAccountWithdraw',
  components: {
    [AccountWithdraw.name]: AccountWithdraw
  },
  methods: {
    resultHandler(accTradeId) {
      this.$router.push({ name: 'FundAccountWithdrawResult', query: { accTradeId } })
    }
  }
}
</script>
